import React from 'react';
import { Link } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { PageFooter } from './footer';

let classNames = require('classnames/bind');


class Question extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
        this.toggleOpen = this.toggleOpen.bind(this);
    }

    toggleOpen() {
        this.setState(prevState => ({
          open: !prevState.open
        }));
    };

    render() {
        const questionClasses = classNames("Question", {"open": this.state.open, "first": this.props.first});

        return (
            <div
                className={questionClasses}
                onClick={this.toggleOpen}
            >
                <div className="Question-qWrapper">
                    <p href="#" className="Question-q">
                       {this.props.question}
                    </p>
                    <div className="Question-arrow">
                        <img src={process.env.PUBLIC_URL + '/arrow.svg'} alt=""/>
                    </div>
                </div>
                <div className="Question-a">
                    {this.props.children}
                </div>
            </div>
        );
    };
};


class Faq extends React.Component {
    componentDidMount() {
        AOS.init({
            duration: 400,
            anchor: '#app',
            placement: 'top-center',
            easing: 'ease-in',
            delay: 800,
        });
    }

    render() {
        return (
            <div className="MainContainer">
                <div className="HalfContainer">
                    <h1
                        data-aos="fade-up"
                        data-aos-delay="200"
                        className="Type-h1"
                    >
                        Questions?
                    </h1>
                    <div data-aos="fade">
                        <h2 className="Type-h2 u-mb-2">
                            What we look for
                        </h2>
                        <Question question={'What is your investment criteria?'} first>
                            <p className="Type-body">
                                <strong>A Remarkable Team:</strong> We are looking for formidable teams that have a big vision, the substance to get there, and the tenacity to break through brick walls.
                            </p>
                            <p className="Type-body">
                                <strong>Early Stage Companies:</strong> We prefer to enter at the seed and Series A round, as we find we can add the most value there. We support founders in raising follow-on capital from other top VCs for subsequent rounds.
                            </p>
                            <p className="Type-body">
                                <strong>Demonstrable Traction:</strong> While our qualifications differ depending on industry, we look for companies that can demonstrate early product-market fit. This means you've moved beyond the idea stage and have compelling data that proves your early users/customers want what you are providing.
                            </p>
                            <p className="Type-body">
                                <strong>Tech and Tech-Enabled</strong> We are open to tech and tech-enabled companies in any industry. To see some of the industries that we currently support, check out our <Link className="Type-link" to="/companies">companies</Link>.
                            </p>
                            <p className="Type-body">
                                <strong>Big Markets:</strong> We fund companies with the potential for enormous growth. We look for startups that serve large, multi-billion dollar total addressable markets (TAMs).
                            </p>
                            <p className="Type-body">
                                <strong>Strong Moats:</strong> We seek companies featuring business models with sustainable competitive advantages, such as network effects, high and growing switching costs, intellectual property, brand, and proprietary & unique data acquisition.
                            </p>
                            <p className="Type-body">
                                <strong>Local and Global Reach:</strong> Though we are based in Silicon Valley, we invest globally. FundersClub has funded startups in 21 countries across the globe, and we are always looking to expand into new countries.
                            </p>
                        </Question>
                        <Question question={'Am I too early to approach FCVC about investment?'}>
                            <p className="Type-body">
                                As a Seed VC, we generally want to connect as early as possible, and have partnered with startups when they were as young as a few months old. However there are certain circumstances where it’s too early to start a conversation with us:
                            </p>
                            <p className="Type-body">
                                If you can’t yet prove that early users or customers want what you’re providing (without relying on high level market data / surveys), or if your startup is still at the idea stage, Yes, you’re too early <sup>[1]</sup>
                            </p>
                            <p className="Type-body u-mb-2">
                                If you’re not about to begin fundraising or not already fundraising, Yes, you’re too early <sup>[2]</sup>
                            </p>
                            <p className="Type-caption">
                                [1] We generally do not invest before you’ve validated that your business resonates with users or customers. We believe in lean demand validation strategies, and think founders who figure out how to bootstrap to this point or get there with family/friends/angel capital only have a better chance of building a capital efficient business moving forward. We are also more meaningfully able to help startups that have already proven early demand. This means if you haven’t meaningfully engaged with users or customers yet, it’s too early to approach us. As a Seed investor, our bar for early product-market fit is a lot lower than for a Series A investor (in fact, we usually invest 6-18 months before Series A), but we are best suited to help founders who’ve proven at least the most basic assumption of their business--that they are building something users or customers want.
                            </p>
                            <p className="Type-caption">
                                [2] We value founders’ time, and believe that founders should either be in fundraising mode or not, despite many VCs’ desire to talk to you while you’re not fundraising to “build the relationship”. The problem is you cannot split your time an infinite number of ways, and we don’t recommend taking your attention away from building the business in order to talk with VCs--unless you’re fundraising. If you’re not 100% committed to raising capital and not about to kick off a fundraising process or not already midway through one, it’s too early to approach us. Once you are or if you’re about to kick off raising, we’d be happy to connect, and once an investor, we’d love to be helpful on an ongoing basis, and form a deep relationship that spans the life of your business (and beyond).
                            </p>
                        </Question>
                        <Question question={'I’m raising Series A (or Series B or later), should I still reach out?'}>
                            <p className="Type-body">
                                If you’re raising Series A, and think we can be a valuable co-investor alongside a lead investor, you should reach out.
                            </p>
                            <p className="Type-body">
                                If you’re raising Series B or later, unfortunately that is too late in the journey for us to consider starting a new partnership.
                            </p>
                            <p className="Type-body">
                                For companies that we first invest in at Seed or Series A, we regularly follow-on and invest in their later rounds (Series A, B, C, and D) whenever possible. We prefer to form brand new partnerships at Seed, or at latest, Series A.
                            </p>
                        </Question>
                        <h2 className="Type-h2 u-mb-2 u-mt-4">
                            Investment process and investment
                        </h2>
                        <Question question={'What is the evaluation process and how do I get started?'} first>
                            <ol className="Type-list">
                                <li>
                                    <strong>Get in Contact.</strong> You have a much higher chance of getting an interview with our team via a warm introduction from an existing portfolio founder of ours, or from someone in our broader network who knows one of our partners or other team members. However, if you are unable to secure a warm introduction to us, you can <a className="Type-link" rel="noopener noreferrer" target="_blank" href="https://fundersclub.com/founders/apply">apply online to FundersClub</a>, and your application will reach us at FCVC if you qualify for investment.
                                </li>
                                <li>
                                    <strong>Initial Review.</strong> A member of our venture team will set up a time to speak with you to learn more about your company and walk you through our investment process. We aim to use this meeting to objectively and efficiently determine whether your business is a possible fit.
                                </li>
                                <li>
                                    <strong>Investment Committee Review.</strong> Upon passing initial review, we will schedule your review by our Investment Committee. During this process, one or more partners will dive deeper into your business with you. We aim to get back to applicants within a week after this meeting to communicate whether we will be moving forward.
                                </li>
                                <li>
                                    <strong>Investment.</strong> If you have reached this point, your company is among the top 2% or less of startups we review every year. Congrats! You also now qualify to raise additional capital from FundersClub, the online VC platform we built, available only to founders such as yourself.
                                </li>
                            </ol>
                        </Question>
                        <Question question={'What size checks do you write?'}>
                            <p className="Type-body">
                                When investing at Seed, we typically write checks of ~$500k to ~$2M from our FCVC fund.
                            </p>
                            <p className="Type-body">
                                As a recipient of a FCVC investment, at your option, you also qualify for an additional $100,000-$1M Seed investment via the online VC platform we built, FundersClub.
                            </p>
                            <p className="Type-body">
                                The FundersClub investment is managed solely by us, takes only 1 line on your cap table, and you continue to have and interface with just 1 investor (us). Yet beyond the additional capital, you also gain the experience and connections of a global network of business owners, executives, and leaders that are able to participate through us via FundersClub. See the Resources question below for more info on the benefits of FundersClub.
                            </p>
                            <p className="Type-body">
                                We also invest in later follow-on rounds, including multi-million dollar check sizes, alongside Series A, B, C, and D lead investors.
                            </p>
                        </Question>
                        <h2 className="Type-h2 u-mb-2 u-mt-4">
                            Working with FCVC
                        </h2>
                        <Question question={'What resources can I expect from FCVC and how involved will FCVC be with my company?'} first>
                            <p className="Type-body">
                                On the extremes of a hands-on investor who sits on your Board to a hands-off investor who you never hear from, we fall closer to the former, but we do not take Board seats. Our aim is to be responsive to your requests for help, and to proactively flag areas where we can help when we see an opportunity to do so. A sign we’re doing well by you is being your first phone call, in both good times and bad times.
                            </p>
                            <p className="Type-body">
                                We like to tailor our support to your specific needs. However, our general strengths include:
                            </p>
                            <ul className="Type-list">
                                <li>
                                    Early stage company-building, management, and growth advice, constantly informed and updated by our portfolio companies’ journeys
                                </li>
                                <li>
                                    Benchmarking company performance and metrics, possible thanks to our ever growing company KPI data set
                                </li>
                                <li>
                                    Deep fundraising advice, know-how, and warm intros to fellow top Seed, Series A, and later stage VC firms. Our most frequent follow-on investors are Sequoia Capital and Andreessen Horowitz.
                                </li>
                            </ul>
                            <p className="Type-body">
                                For founders also taking a check from FundersClub, you additionally benefit from:
                            </p>
                            <ul className="Type-list">
                                <li>
                                    Founder Community. If you are facing a challenge, odds are another founder within our portfolio knows how to navigate it. We bring our powerful community of over 630+ founders & co-founders together both online and at in-person events.
                                </li>
                                <li>
                                    Professional Network. Expand your rolodex with 20,000+ angel investors, 79% of whom are C-level executives, directors, managers, and business owners, and all of whom are in a position to potentially be helpful with advice and connections.
                                </li>
                                <li>
                                    FundersClub Resources. We have invested in portfolio resources including discounts from vetted vendors (e.g. $100,000 free Amazon Web Services credit), and press amplification of major milestones of general interest across our social channels.
                                </li>
                            </ul>
                        </Question>
                        <Question question={'How do I work with FCVC for later rounds?'}>
                            <p className="Type-body">
                                Given our scale, past experience, and ever-growing data points on follow-on rounds, we are well positioned to meaningfully help on follow-on financings. This includes a strong sense of when raising a follow-on round makes sense, how to best communicate your progress and vision to follow-on lead investors, and how to navigate introductions, meetings, and term sheets. We work with founders on honing their pitch deck, blurb, investor list and process, by making warm introductions to top follow-on round lead VCs, by helping to navigate term sheets, by pre-committing to participate, and by co-investing in follow-on rounds.
                            </p>
                        </Question>
                    </div>
                </div>
                <br/><br/>
                <PageFooter/>
            </div>
        );
    };
};
export default Faq;



// WEBPACK FOOTER //
// ./src/components/faq.js